var map = {
	"./kubevirt.io.virtualmachine": "7e7c",
	"./kubevirt.io.virtualmachine.vue": "7e7c",
	"./management.cattle.io.project": "10b7",
	"./management.cattle.io.project.vue": "10b7",
	"./pod": "9974",
	"./pod.vue": "9974"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c498";